import axios from "axios";
import qs from "qs";
import React, { useCallback, useEffect, useState } from "react";
import { Alert, Button, Card, FormControl } from "react-bootstrap";
import CopyToClipboard from "react-copy-to-clipboard";
import Highlight from "react-highlight";
import { defineMessages, FormattedMessage } from "react-intl";
import styled from "styled-components";
import format from "xml-formatter";
import { withAuthorizationVerifier } from "../../components/authorization-verifier";
import { FullWidthLoader } from "../../components/full-width-loader";
import { useKeycloakAuthz } from "../../components/keycloak-provider";
import { SectionHeading } from "../../components/section-heading";
import Selector from "../../components/selector";
import { useUserPropertyTickers } from "../../components/user-tickers-providers";
import { ChannelManagerAPIPromiseClient } from "../../gen/witbooking/backoffice/channelmanager/v1/channelmanager_api_grpc_web_pb";
import { GetPropertyChannelManagersRequest } from "../../gen/witbooking/backoffice/channelmanager/v1/channelmanager_api_pb";
import { ACCESS_DENIED, getPropertyRpt } from "../../lib/auth";
import { useGrpcClient, useInternalGrpcCall } from "../../lib/grpc";
import { defaultFormMessages } from "../shared/crud/form";
import { defaultListMessages } from "../shared/crud/list";

import { MIDDLEWARE_URL } from "../witadmin/request";

const messages = {
  ...defaultFormMessages,
  ...defaultListMessages,
  ...defineMessages({
    title: {
      id: "internalmenu.integrations.channelManagerReservationLog",
      defaultMessage: "ChannelManager reservation log",
    },
    propertyTickerSelectPlaceholder: {
      id: "channelManager.placeholder.propertyTicker",
      defaultMessage: "Engine identifier",
    },
    channelsSelectPlaceholder: {
      id: "channelManagerReservationLog.placeholder.channels",
      defaultMessage: "Channel manager",
    },
    search: {
      id: "channelManagerReservationLog.button.search",
      defaultMessage: "Search",
    },
    reservationId: {
      id: "channelManagerReservationLog.label.reservationId",
      defaultMessage: "Reservation id",
    },
    copy: {
      id: "channelManagerReservationLog.button.reservationId",
      defaultMessage: "Copy",
    },
    copied: {
      id: "channelManagerReservationLog.button.reservationId",
      defaultMessage: "Copied!",
    },
  }),
};

const channelManagersList = {
  SITEMINDER: "SITEMINDER",
  SITEMINDERPROXY: "SITEMINDERPROXY",
  PARITYRATE: "PARITYRATE",
  DINGUS: "DINGUS",
  DINGUSPROXY: "DINGUSPROXY",
  TMS4C: "TMS4C",
  TMS4CPROXY: "TMS4CPROXY",
  ICNEA: "ICNEA",
  FLEXMYROOM: "FLEXMYROOM",
  PRESTIGE: "PRESTIGE",
  YIELDPLANET: "YIELDPLANET",
  YIELDPLANETPROXY: "YIELDPLANETPROXY",
  BESAFE: "BESAFE",
  O2MAD: "O2MAD",
  FIDELTOUR: "FIDELTOUR",
  PUSHTECH: "PUSHTECH",
  THN: "THN",
  GUESTPRO: "GUESTPRO",
  GRITCHEN: "GRITCHEN",
  ACIGRUP: "ACIGRUP",
  ACIGRUP_PROXY: "ACIGRUP_PROXY",
  RATETIGER: "RATETIGER",
  EMEXS: "EMEXS",
  ULYSES_CLOUD: "ULYSES_CLOUD",
  ULYSES_CLOUD_PROXY: "ULYSES_CLOUD_PROXY",
  TRIPRESALE: "TRIPRESALE",
  VIQAL: "VIQAL",
  CAMPING_PULL: "CAMPING_PULL",
  TRANSFEREXP: "TRANSFEREXP",
  ADGRAVITY: "ADGRAVITY",
  WEBCAMP: "WEBCAMP",
  SALESFORCESERCOTEL: "SALESFORCESERCOTEL",
  HIKEFOXTER: "HIKEFOXTER",
  HOTELLINKING: "HOTELLINKING",
  OPERA_SERCOTEL: "OPERA_SERCOTEL",
  HOSTNAME: "HOSTNAME",
  RK_PEOPLE: "RK_PEOPLE",
  GARCIAANDMAISEL: "GARCIAANDMAISEL",
  VILALARA: "VILALARA",
  REDK: "REDK",
};

function generateAxiosOptions({
  channel,
  propertyTicker,
  reservationId,
}: {
  channel: string;
  propertyTicker: string;
  reservationId: string;
}): any {
  switch (channel) {
    case channelManagersList.SITEMINDER:
    case channelManagersList.PARITYRATE:
      return {
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "text/xml",
        },
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/Execute/SiteMinder/getOTAHotelResNotifRQ`,
        data: qs.stringify({
          reservationId: reservationId,
          hotelTicker: propertyTicker,
        }),
      };
    case channelManagersList.SITEMINDERPROXY:
    case channelManagersList.FLEXMYROOM:
    case channelManagersList.BESAFE:
      return {
        method: "get",
        headers: {
          Accept: "text/xml",
        },
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/siteminderproxy/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    case channelManagersList.YIELDPLANET:
      return {
        method: "get",
        headers: {
          Accept: "text/xml",
        },
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/yieldplanet/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    case channelManagersList.YIELDPLANETPROXY:
      return {
        method: "get",
        headers: {
          Accept: "text/xml",
        },
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/yieldplanetproxy/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    case channelManagersList.DINGUS:
      return {
        method: "post",
        headers: {
          "content-type": "text/xml",
        },
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/dingus/BookingRetrievalRQ`,
        data: `<?xml version="1.0" encoding="utf-8"?>
                <BookingRetrievalRQ>
                  <User>j.lucic@witbooking.com</User>
                  <Password>qwerty</Password>
                  <HotelCode>${propertyTicker}</HotelCode>
                  <ReservationID>${reservationId}</ReservationID>
                </BookingRetrievalRQ>`,
      };
    case channelManagersList.TMS4C:
    case channelManagersList.TMS4CPROXY:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/tms4c/getOTAResRetrieveRS?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.ICNEA:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/icnea/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.PRESTIGE:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/prestige/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.O2MAD:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/O2MAD/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    case channelManagersList.THN:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/THN/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.FIDELTOUR:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/fideltour/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.PUSHTECH:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/PUSHTECH/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.ACIGRUP:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/acigrup/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.ACIGRUP_PROXY:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/acigrupproxy/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.GUESTPRO:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/guestpro/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.GRITCHEN:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/gritchen/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.RATETIGER:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/rate-tiger/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    case channelManagersList.EMEXS:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/emexs/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    case channelManagersList.ULYSES_CLOUD:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/ulyses_cloud/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    case channelManagersList.ULYSES_CLOUD_PROXY:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/ulyses_cloud_proxy/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    case channelManagersList.TRIPRESALE:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/tripresale/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    case channelManagersList.VIQAL:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/VIQAL/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.CAMPING_PULL:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/campingpull/getOTAResRetrieveRS?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.TRANSFEREXP:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/TRANSFEREXP/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.ADGRAVITY:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/ADGRAVITY/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.WEBCAMP:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/webcamp/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.SALESFORCESERCOTEL:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/SALESFORCESERCOTEL/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };

    case channelManagersList.HIKEFOXTER:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/HIKEFOXTER/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    case channelManagersList.HOTELLINKING:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/HOTELLINKING/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    case channelManagersList.HOSTNAME:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/HOSTNAME/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    case channelManagersList.RK_PEOPLE:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/RK_PEOPLE/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    case channelManagersList.GARCIAANDMAISEL:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/GARCIAANDMAISEL/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    case channelManagersList.VILALARA:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/VILALARA/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    case channelManagersList.REDK:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/REDK/getOTAHotelResNotifRQ?reservationId=${reservationId}&hotelTicker=${propertyTicker}`,
      };
    default:
      return {
        method: "get",
        responseType: "text",
        url: `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/endpoint/establishment/${propertyTicker}/reservation/${reservationId}`,
      };
  }
}

interface OperationError {
  message: string;
}
type Option = { value: string; label: string };

const Container = styled.div``;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  > * {
    margin: 15px 0;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  > * {
    margin-left: 15px;
  }
`;

const CopyButton = styled(Button)`
  min-width: 85px;
`;

const Label = styled.div`
  font-size: 18px;
  margin-bottom: -10px;
`;
const StyledHighlight = styled(Highlight)`
  font-size: 12px;
`;

const HighlightContainer = styled.div`
  display: flex;
  justify-content: center;
  background-color: #f7f7f7;
  padding: 20px;
`;

const ReservationIdInput = styled(FormControl)``;

function ChannelReservationLog() {
  const userPropertyTickersList = useUserPropertyTickers();
  const channelManagerGrpcClient = useGrpcClient(ChannelManagerAPIPromiseClient);
  const getPropertyChannelManagers = useInternalGrpcCall(
    channelManagerGrpcClient,
    channelManagerGrpcClient.getPropertyChannelManagers
  );

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<OperationError | null | undefined>(undefined);
  const [propertyTickerOptions, setPropertyTickerOptions] = useState<Option[]>([]);
  const [propertyTickerOption, setPropertyTickerOption] = useState<Option | null | undefined>(
    undefined
  );

  const [propertyChannels, setPropertyChannels] = useState<Option[]>([]);
  const [channelOption, setChannelOption] = useState<Option | null | undefined>(undefined);
  const [reservationId, setReservationId] = useState<string | undefined>(undefined);
  const [reservationData, setReservationData] = useState<string | undefined>(undefined);
  const [copied, setCopied] = useState<boolean>(false);
  const keycloakAuthz = useKeycloakAuthz();

  useEffect(() => {
    const fetchPropertyTickers = async () => {
      setLoading(true);
      setPropertyTickerOptions(
        userPropertyTickersList.map(option => ({ value: option, label: option }))
      );
      setLoading(false);
    };
    fetchPropertyTickers();
  }, [userPropertyTickersList]);

  useEffect(() => {
    const fetchPropertyChannels = async () => {
      if (!propertyTickerOption || !propertyTickerOption.value) {
        return;
      }
      setLoading(true);
      setError(undefined);
      setChannelOption(undefined);
      try {
        const propertyChannels = await getPropertyChannelManagers(
          new GetPropertyChannelManagersRequest(),
          { "x-property": propertyTickerOption.value }
        );
        const availableChannels = propertyChannels
          .getChannelManagersList()
          .map(option => ({ value: option, label: option }));
        setPropertyChannels(availableChannels);
        setChannelOption(availableChannels && availableChannels[0]);
      } catch (e) {
        if (e === ACCESS_DENIED) {
          console.error("Access denied", e);
          setError({ message: "Access denied" });
        } else {
          console.error("Error retrieving children", e);
          setError({ message: "Error retrieving children" });
        }
      }
      setLoading(false);
    };
    fetchPropertyChannels();
  }, [propertyTickerOption, keycloakAuthz, getPropertyChannelManagers]);

  const handleSelectPropertyTicker = useCallback(
    selectedOption => setPropertyTickerOption(selectedOption),
    [setPropertyTickerOption]
  );

  const handleChannelSelect = useCallback(selectedOption => setChannelOption(selectedOption), [
    setChannelOption,
  ]);

  const handleReservationIdChange = useCallback(event => setReservationId(event.target.value), [
    setReservationId,
  ]);

  const handleMarkCopied = useCallback(() => setCopied(true), [setCopied]);

  const fetchReservationLog = useCallback(async () => {
    if (!propertyTickerOption || !channelOption || !reservationId) {
      return;
    }
    setError(undefined);
    setReservationData(undefined);
    setCopied(false);
    try {
      const rpt = await getPropertyRpt(propertyTickerOption.value, keycloakAuthz);
      const axiosOptions = generateAxiosOptions({
        channel: channelOption.value,
        propertyTicker: propertyTickerOption.value,
        reservationId: reservationId,
      });
      const response = await axios({
        ...axiosOptions,
        headers: {
          ...axiosOptions.headers,
          Authorization: `Bearer ${rpt}`,
          "x-property": propertyTickerOption.value,
        },
      });
      if (!response.data) {
        setError({ message: "No reservation found" });
      } else {
        setReservationData(response.data);
      }
    } catch (e) {
      if (e === ACCESS_DENIED) {
        setError({ message: "Access denied" });
      } else {
        setError({ message: "Unexpected error" });
      }
    }
  }, [channelOption, propertyTickerOption, reservationId, keycloakAuthz]);

  if (loading) {
    return <FullWidthLoader />;
  }

  return (
    <Container>
      <SectionHeading>
        <FormattedMessage {...messages.title} />
      </SectionHeading>
      <Card className="ml-4 mr-4 mb-4 mt-4">
        <FormContainer>
          <Label>
            <FormattedMessage {...messages.propertyTickerSelectPlaceholder} />
          </Label>
          <Selector
            options={propertyTickerOptions}
            value={propertyTickerOption}
            onChange={handleSelectPropertyTicker}
            placeholder={<FormattedMessage {...messages.propertyTickerSelectPlaceholder} />}
          />
          <>
            <Label>
              <FormattedMessage {...messages.channelsSelectPlaceholder} />
            </Label>
            <Selector
              value={channelOption}
              options={propertyChannels}
              onChange={handleChannelSelect}
              placeholder={<FormattedMessage {...messages.channelsSelectPlaceholder} />}
            />
          </>

          <>
            <Label>
              <FormattedMessage {...messages.reservationId} />
            </Label>
            <ReservationIdInput
              type="text"
              placeholder="MXXXXXX"
              onChange={handleReservationIdChange}
            />
          </>

          {error && (
            <Alert variant="danger">
              <strong>{error.message}</strong>
            </Alert>
          )}

          <ButtonContainer>
            {reservationData && (
              <CopyToClipboard text={format(reservationData)} onCopy={handleMarkCopied}>
                <CopyButton
                  variant={copied ? "success" : "primary"}
                  type="button"
                  disabled={!propertyTickerOption || !channelOption || !reservationId}>
                  {copied ? (
                    <FormattedMessage {...messages.copied} />
                  ) : (
                    <FormattedMessage {...messages.copy} />
                  )}
                </CopyButton>
              </CopyToClipboard>
            )}
            <Button
              variant="primary"
              type="button"
              onClick={fetchReservationLog}
              disabled={!propertyTickerOption || !channelOption || !reservationId}>
              <FormattedMessage {...messages.search} />
            </Button>
          </ButtonContainer>

          {reservationData && (
            <HighlightContainer>
              <StyledHighlight className="xml">{format(reservationData)}</StyledHighlight>
            </HighlightContainer>
          )}
        </FormContainer>
      </Card>
    </Container>
  );
}

export default withAuthorizationVerifier(ChannelReservationLog);
